module.exports = __webpack_public_path__ + "img/renlianshibie.ef7ca858.png";